const baseUrl = import.meta.env.VITE_APP_BACKEND_API_URL as string;

export const countryEndpoints = {
  countries: () => `${baseUrl}/countries`
};
